export default class CreateProductCtrl {

  constructor ($scope, $timeout, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, $cookies, $stateParams, $state, GlobalConfig, GlobalSrv) {
    var createProductVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = $cookies.getObject('currentUser')
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId,
      name: currentUser.name
    }

    // //VARIABLES
    createProductVm.idParent = WorkPlanModalSrv.getVariable()
    createProductVm.isEditing = Number($stateParams.workplanTeacherActivityId)
    createProductVm.knowledgeList = []
    createProductVm.productFormulatedList = []
    createProductVm.typeProductList = []
    createProductVm.subTypeProductList = []
    createProductVm.associatedProjecttList = []
    createProductVm.groupInvestigationList = []
    createProductVm.isTouchedfinancials = false
    createProductVm.createOrEdit = 'Agregar'
    createProductVm.createOrEditTitle = 'agregar'
    createProductVm.createOrEditModal = 'agregar'
    createProductVm.textCreateOrEdit = texts.saved
    createProductVm.createOrEditMV = texts.createDialog
    createProductVm.active = GlobalConfig.generals.active
    createProductVm.notActive = GlobalConfig.generals.notActive
    createProductVm.isNotification = createProductVm.notActive
    createProductVm.rangeType = GlobalConfig.periods.rangeType
    createProductVm.periodsArray = []
    createProductVm.typePeriod = []
    createProductVm.isTouchedPeriods = false
    createProductVm.selectedTypePeriod = {}
    createProductVm.startDate = null
    createProductVm.endDate = null
    createProductVm.minStartDate = moment().toDate()
    createProductVm.minEndDate = new Date()
    createProductVm.buttonDisabled = false
    createProductVm.hoursChildren = 0
    createProductVm.showHoursChildren = false
    createProductVm.isFeedback = currentUser.isFeedback
    createProductVm.dt_start = $cookies.get('wp_start')
    createProductVm.dt_end = $cookies.get('wp_end')

    // // //METHODS
    createProductVm.validateForm = validateForm
    createProductVm.showErrorMessages = showErrorMessages
    createProductVm.hasError = hasError
    createProductVm.startDateChange = startDateChange
    createProductVm.funSelectedPeriod = funSelectedPeriod
    createProductVm.validateCheklistPeriods = validateCheklistPeriods
    createProductVm.close = close
    createProductVm.addProduct = addProduct
    createProductVm.addActivityProduct = addActivityProduct
    createProductVm.cleanRangeType = cleanRangeType
    createProductVm.hoursChange = hoursChange

    createProductVm.updateRangeType = (val) => {
      createProductVm.rangeType = val
      createProductVm.periodsArray = []
      createProductVm.startDate = null
      createProductVm.endDate = null
    }
    createProductVm.updateRangeData = (val) => {
      createProductVm.periodsArray = val['periods']
      createProductVm.startDate = val['dates'][0]
      createProductVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createProductVm.isEditing) {
        createProductVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createProductVm.activityId = GlobalConfig.minorActivityId.productParent
        createProductVm.createOrEdit = 'Editar'
        createProductVm.createOrEditModal = 'editar'
        createProductVm.createOrEditTitle = 'editar'
        createProductVm.createOrEditMV = texts.editDialog
        createProductVm.textCreateOrEdit = texts.modified
        getDataProduct()
      }

      if (createProductVm.idParent) {
        createProductVm.isEditing = true
        if (createProductVm.idParent.children !== 'ADD') {
          createProductVm.createOrEditMV = texts.editDialog
          createProductVm.textCreateOrEdit = texts.modified
          createProductVm.createOrEdit = 'Editar'
          createProductVm.createOrEditModal = 'editar'
          createProductVm.createOrEditTitle = 'editar'
          createProductVm.workplanTeacherActivityId = createProductVm.idParent.children.workplanTeacherActivityId
          setValues(createProductVm.idParent.children, createProductVm.idParent.hoursChildren)
        } else {
          createProductVm.hoursChildren = (createProductVm.idParent.hoursChildren ? createProductVm.idParent.hoursChildren : 0)
        }
      }

      WorkPlanSrv.getDataFormProduct.getList(post).$promise.then(
        dataReturn => {
          dataReturn.status ? loadData(dataReturn) : console.log('Comunications problem')
        }
      )
    }

    function loadData (data) {
      createProductVm.knowledgeList = data.listKnowledge.items
      createProductVm.typeProductList = data.listItemsProducts
      createProductVm.subTypeProductList = data.listSubItemsProducts
      createProductVm.associatedProjecttList = data.listProjects
      createProductVm.typePeriod = data.listPeriods
      updateView()
    }

    function showErrorMessages (input) {
      if (input) {
        return input.$dirty || input.$touched
      } else {
        return false
      }
    }

    function hasError (input) {
      if (input && input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function validateForm (form) {
      return form.$invalid ||
             createProductVm.validateCheklistPeriods()
    }

    function updateView () {
      createProductVm.viewLoaded = false
      $timeout(() => {
        createProductVm.viewLoaded = true
      }, 1)
    }

    function startDateChange () {
      let m = moment(createProductVm.startDate)
      createProductVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function validateCheklistPeriods () {
      return (createProductVm.rangeType == 1 &&
        createProductVm.periodsArray ? createProductVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createProductVm.periodsArray.includes(period.periodId)) {
          createProductVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createProductVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createProductVm.periodsArray.splice(index, 1)
        }
      }
      createProductVm.isTouchedPeriods = true
    }

    function close () {
      return $mdDialog.hide()
    }

    function addProduct (isExecution) {
      if (createProductVm.notification == true) {
        createProductVm.notification = 1
      }
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {
      var product = {
        activityId: GlobalConfig.minorActivityId.productParent,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createProductVm.title,
        description: createProductVm.description,
        hoursPlanning: createProductVm.plannedHours,
        projectId: createProductVm.associatedProject,
        itemKnowledgeId: createProductVm.knowledge,
        itemProductId: createProductVm.typeProduct,
        itemSubProductId: createProductVm.subTypeProduct,
        isNotification: createProductVm.notification,
        timeRangeTypeId: createProductVm.rangeType,
        origin: origin,
        hoursChildren: parseInt(createProductVm.hoursChildren),
        isFeedbackActivity: createProductVm.isFeedback
      }

      if (createProductVm.isEditing) {
        product.workplanTeacherActivityId = createProductVm.workplanTeacherActivityId
      }

      if (parseInt(createProductVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createProductVm.periodsArray) {
          var temp = {
            periodId: createProductVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        product.periods = arrayPeriod
      } else {
        product.startDate = new Date(createProductVm.startDate)
        product.endDate = new Date(createProductVm.endDate)
      }
      createProductVm.modalType = texts.modalTypeId.product
      addOrEditProduct(product, createProductVm.modalType)
    }

    function getNotify (isProduct) {
      let reviewers = GlobalSrv.getReviewersAndEvaluator()
      reviewers.forEach((reviewer) => {
        if(isProduct)
          getSendNotify(reviewer)
        else
          getSendNotifyActivity(reviewer)
      })
    }

    function getSendNotify (idUser) {
      const nameUser = currentUser.dsFullname
      const data = {
        idUser: idUser,
        dsName: 'Notificación, se agregó producto',
        dsDescription: 'El profesor ' + nameUser + ' ha agregado un producto',
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 1
      }
      GlobalSrv.sendNotification(data)
    }

    function getSendNotifyActivity (idUser) {
      const nameUser = currentUser.dsFullname

      const data = {
        idUser: idUser,
        dsName: 'Notificación, se ha registrado actividades en investigación',
        dsDescription: 'El profesor ' + nameUser + ' ha registrado actividades en investigación',
        idNotification_delivery_type: GlobalConfig.notificationType.email,
        is_grouped: 1
      }
      GlobalSrv.sendNotification(data)
    }

    function addOrEditProduct (product, modalType) {
      createProductVm.buttonDisabled = true
      let action = 'ADD'
      if (createProductVm.workplanTeacherActivityId) {
        action = 'EDIT'
      }

      WorkPlanSrv.addActivityProduct.save(product).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          product.workplanTeacherActivityId = dataReturn.workplanTeacherActivityId
          product.hoursPlanned = product.hoursPlanning
          if (createProductVm.idParent && createProductVm.idParent.children
            && typeof createProductVm.idParent.children !== 'string') {
            createProductVm.idParent.children.name = product.name
            createProductVm.idParent.children.periodId = product.periodId
            createProductVm.idParent.children.description = product.description
            createProductVm.idParent.children.startDate = product.startDate
            createProductVm.idParent.children.endDate = product.endDate
            createProductVm.idParent.children.timeRangeTypeId = product.timeRangeTypeId
          }
          getNotify(isProduct(modalType))
          if (isProduct(modalType)) {
            confirmProductAction(modalType)
          } else {
            WorkPlanModalSrv.setVariable({status: dataReturn.status, child: product, action: action})
            confirmProductAction(modalType)
            return $mdDialog.hide()
          }
        } else {
          console.log('Error Comunications')
          createProductVm.buttonDisabled = false
        }
      }, function (data) {
        console.log(data)
      })
    }

    function confirmProductAction (modalType) {
      let header = {
        createOrEdit: createProductVm.createOrEditMV,
        textCreateOrEdit: createProductVm.textCreateOrEdit,
        itemName: createProductVm.title,
        nameModal: (isProduct(modalType) ? texts.modalTypeName.product : texts.modalTypeName.activity),
        modalType: modalType
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataProduct () {
      let post = {
        workplanTeacherActivityId: parseInt(createProductVm.workplanTeacherActivityId)
      }
      WorkPlanSrv.getProductByActivityId.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          if (!dataReturn.data.parent) {
            createProductVm.product = dataReturn.data.childs[0]
          } else {
            createProductVm.product = dataReturn.data.parent
            createProductVm.child = dataReturn.data.childs
          }
          setValues(createProductVm.product, createProductVm.product.hoursChildren)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (product, hoursChildren) {
      const dateValueSetter = (date) => moment(date, 'YYYY-MM-DD').isValid() ? moment(date, 'YYYY-MM-DD').toDate() : null
      createProductVm.title = product.name
      createProductVm.description = product.description
      createProductVm.associatedProject = product.projectId
      createProductVm.knowledge = product.itemKnowledgeId
      createProductVm.typeProduct = product.itemProductId
      createProductVm.subTypeProduct = product.subItemProductId
      createProductVm.rangeType = product.timeRangeTypeId
      createProductVm.dt_start = dateValueSetter(product.startDate)
      createProductVm.dt_end = dateValueSetter(product.endDate)
      createProductVm.plannedHours = product.hoursPlanned
      createProductVm.notification = Boolean(product.isNotification === 1)
      // createProductVm.hoursChildren = (product.hoursChildren ? product.hoursChildren : 0)
      createProductVm.periodsArray = [] // product.periods
      createProductVm.selectedTypePeriod = {}
      createProductVm.hoursChildren = (hoursChildren ? hoursChildren : 0)

      if (parseInt(createProductVm.rangeType) === GlobalConfig.periods.rangeType) {
        if (product.periodId) {
          createProductVm.periodsArray = product.periodId.split(',').map(id => {
            createProductVm.selectedTypePeriod[Number(id)] = true
            return Number(id)
          })
        } else {
          createProductVm.periodsArray = product.periods
        }
      }
      if (product.startDate) {
        var startDateNew = moment(product.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createProductVm.minStartDate = moment(product.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createProductVm.isEditing = true
    }

    function addActivityProduct (activity) {
      createJsonActivity()
    }

    function createJsonActivity () {
      let activity = {
        activityId: GlobalConfig.minorActivityId.productChild,
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        name: createProductVm.title,
        description: createProductVm.description,
        hoursPlanning: createProductVm.plannedHours,
        parentActivityId: createProductVm.idParent.workplanTeacherActivityIdParent,
        hoursChildren: createProductVm.idParent.hoursChildren,
        timeRangeTypeId: createProductVm.rangeType,
        isFeedbackActivity: createProductVm.isFeedback
      }

      if (activity.hoursChildren == 0) {
        activity.hoursPlanning = 0
      }

      if (parseInt(createProductVm.rangeType) === GlobalConfig.periods.rangeType) {
        var periodIds = ''
        var arrayPeriod = []
        for (var index in createProductVm.periodsArray) {
          var temp = {
            periodId: createProductVm.periodsArray[index]
          }
          periodIds = periodIds + createProductVm.periodsArray[index] + ','
          arrayPeriod.push(temp)
        }
        activity.periods = arrayPeriod
        activity.periodId = periodIds.slice(0, -1)
      } else {
        activity.startDate = createProductVm.startDate
        activity.endDate = createProductVm.endDate
      }
      if (createProductVm.isEditing) { activity.workplanTeacherActivityId = createProductVm.workplanTeacherActivityId }

      createProductVm.modalType = texts.modalTypeId.activity
      addOrEditProduct(activity, createProductVm.modalType)
    }

    function isProduct (value) {
      return value == texts.modalTypeId.product
    }

    function cleanRangeType () {
      if (parseInt(createProductVm.rangeType) == GlobalConfig.periods.rangeType) {
        createProductVm.startDate = null
        createProductVm.endDate = null
      } else {
        createProductVm.periodsArray = []
        createProductVm.selectedTypePeriod = null
      }
    }

    function hoursChange (aux) {
      if (aux == null) {
        createProductVm.showHoursChildren = false
      } else {
        createProductVm.showHoursChildren = true
      }
    }
  }// FIN DEL CONSTRUCTOR

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateProductCtrl.$inject = ['$scope', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', '$cookies', '$stateParams', '$state', 'GlobalConfig', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/products/createProduct/createProductCtrl.js